import { render, staticRenderFns } from "./EditVenuePage.vue?vue&type=template&id=b17f653c&scoped=true&"
import script from "./EditVenuePage.vue?vue&type=script&lang=js&"
export * from "./EditVenuePage.vue?vue&type=script&lang=js&"
import style0 from "./EditVenuePage.vue?vue&type=style&index=0&id=b17f653c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17f653c",
  null
  
)

export default component.exports